<button [disabled]="!currencies || !currencies.length" mat-button (click)="$event.stopPropagation(); menu.toggle($event);">{{ title }}<mat-icon svgIcon="arrow_drop_down"></mat-icon></button>
<p-menu #menu appendTo="body" popup="popup" [model]="buildOptions(currencies)"></p-menu>
